// CBT Exam Reducer

const initialState = {
  answers: {}, // Format: { [coursecode]: { [questionId]: answer } }
  examData: null, // Current exam data
  startTime: null, // Exam start time
  timeRemaining: {}, // Format: { [coursecode]: timeRemainingInSeconds }
  questionOrder: {} // Format: { [coursecode]: [questionId1, questionId2, ...] }
};

const CBTExamReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CBT_ANSWER':
      const { coursecode, questionId, answer } = action.payload;
      // Normalize question ID to string for consistency
      const normalizedQuestionId = String(questionId);
      return {
        ...state,
        answers: {
          ...state.answers,
          [coursecode]: {
            ...(state.answers[coursecode] || {}),
            [normalizedQuestionId]: answer
          }
        }
      };

    case 'INITIALIZE_CBT_ANSWERS':
      const { coursecode: initCoursecode, questionIds } = action.payload;
      const existingAnswers = state.answers[initCoursecode] || {};
      
      // Create answer slots for all questions, preserving existing answers
      // Normalize question IDs to strings for consistency
      const initializedAnswers = {};
      questionIds.forEach(qId => {
        const normalizedId = String(qId);
        // Try normalized ID first, then original ID for backward compatibility
        initializedAnswers[normalizedId] = existingAnswers[normalizedId] || existingAnswers[qId] || '';
      });
      
      return {
        ...state,
        answers: {
          ...state.answers,
          [initCoursecode]: initializedAnswers
        }
      };

    case 'CLEAR_CBT_ANSWERS':
      const { coursecode: clearCoursecode } = action.payload;
      const newAnswers = { ...state.answers };
      const newTimeRemaining = { ...state.timeRemaining };
      const newQuestionOrder = { ...state.questionOrder };
      delete newAnswers[clearCoursecode];
      delete newTimeRemaining[clearCoursecode];
      delete newQuestionOrder[clearCoursecode];
      return {
        ...state,
        answers: newAnswers,
        timeRemaining: newTimeRemaining,
        questionOrder: newQuestionOrder
      };

    case 'SET_CBT_EXAM_DATA':
      return {
        ...state,
        examData: action.payload.examData
      };

    case 'SET_CBT_START_TIME':
      return {
        ...state,
        startTime: action.payload.startTime
      };

    case 'SET_CBT_TIME_REMAINING':
      const { coursecode: timeCoursecode, timeRemaining } = action.payload;
      return {
        ...state,
        timeRemaining: {
          ...state.timeRemaining,
          [timeCoursecode]: timeRemaining
        }
      };

    case 'SET_CBT_QUESTION_ORDER':
      const { coursecode: orderCoursecode, questionOrder } = action.payload;
      return {
        ...state,
        questionOrder: {
          ...state.questionOrder,
          [orderCoursecode]: questionOrder
        }
      };

    default:
      return state;
  }
};

export default CBTExamReducer;
